<template>
  <el-dialog
    append-to-body
    :title="Baslik"
    :visible="Modal"
    center
    width="60%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">

      <el-row :gutter="24" v-if="!Kaydet">
        <el-row :gutter="24">
        <el-col :span="20" v-if="Hesap_id==6">
          <el-form-item class="Tooltip" label="Aidatım Bina Kodu" prop="BinaKodu">
            <el-tooltip class="item" effect="dark"
                        content="Bina Ekran > Sayaç Okuma tabındaki Bina Kodu" placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            <el-input v-model="BinaKodu"/>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="Hesap_id==6">
          <el-form-item label="" prop="x">
            <el-button type="danger" class="btn-block" :disabled="!BinaKodu" style="margin-top: 22px"
                       @click="AboneGetir">GETİR
            </el-button>
          </el-form-item>
        </el-col>
          </el-row>
        <!--        https://drive.google.com/file/d/1QbhIOmOYVPNx3vkw3avu7mMpCxlyAvag/view?usp=sharing -->


        <el-row :gutter="24">
          <el-col :span="12" :offset="3">
            <label for="file" type="button" class="el-button el-button--success btn-block">Excel
              Dosyası
              Yükle ve Hazırla <i class="el-icon-upload el-icon-right"></i></label>
            <input type="file" class="el-upload__input" id="file" accept=".xlsx,.xls"
                   @change="ExcelSecimi">
          </el-col>
          <el-col :span="6">
            <a href="https://drive.google.com/uc?authuser=0&id=1QbhIOmOYVPNx3vkw3avu7mMpCxlyAvag&export=download"
               target="_blank" class="el-button el-button--primary btn-block">Şablon İndir <i
              class="el-icon-download el-icon-right"></i></a>
          </el-col>
        </el-row>
      </el-row>
      <el-row :gutter="24" v-if="Kaydet">
        <el-col :span="8">
          <el-form-item label="Site/Bina Adı" prop="Adi">
            <el-input v-model="Form.Adi"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="Açıklama" prop="Aciklama">
            <el-input v-model="Form.Aciklama"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Adres" prop="Adres">
            <el-input type="textarea" v-model="Form.Adres"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Mesken" prop="OkumaUcreti">
            <el-input v-model="Form.OkumaUcreti"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Tahsilat" prop="TahsilUcreti">
            <el-input v-model="Form.TahsilUcreti"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="İlgili Ad Soyad" prop="Ilgili">
            <el-input v-model="Form.Ilgili"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="İlgili Telefon" prop="Telefon">
            <el-input v-model="Form.Telefon" v-mask="'### ### ## ##'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Bölge" prop="Bolge">
            <el-select v-model="Form.Bolge" filterable>
              <el-option
                v-for="item in Bolge"
                :key="item.id"
                :label="item.Adi"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Koordinat" prop="Koordinat">
            <el-input v-model="Form.Koordinat"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Vergi Dairesi" prop="vDairesi">
            <el-input v-model="Form.vDairesi"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Vergi No" prop="vNo">
            <el-input v-model="Form.vNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <hot-table licenseKey="non-commercial-and-evaluation"
                     width="600"
                     height="300"
                     :colHeaders="['Ad Soyad', 'Mesken No', 'M2','Telefon','Blok Adı']"
                     :data="MeskenListe" v-if="MeskenListe"></hot-table>

        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer" v-if="Kaydet">
      <el-button type="primary" size="medium" :disabled="lo" @click="Submit()" icon="el-icon-check">
        Kaydet ve Kuruluma Geç
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {HotTable} from '@handsontable/vue';
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));
export default {
  components: {HotTable},
  props: ['Modal', 'BinaBilgi', 'Baslik'],
  data() {
    return {
      Kaydet: false,
      Hesap_id: null,
      BinaKodu: null,
      MeskenListe: null,
      ExcelData: null,
      Bolge: [
        {id: 1, Adi: '1.Bölge'},
        {id: 2, Adi: '2.Bölge'},
        {id: 3, Adi: '3.Bölge'},
        {id: 4, Adi: '4.Bölge'},
      ],
      Form: {},
      FormHata: {
        Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Adres: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        OkumaUcreti: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        TahsilUcreti: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bolge: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      }
    }
  },
  methods: {
    ExcelSecimi(evt) {
      const files = evt.target.files;
      if (files && files[0]) this._file(files[0]);
    },
    _file(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, {type: 'binary', cellDates: true, cellNF: false, cellText: false});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, {raw: false, header: 1, dateNF: "DD-MM-YYYY"});
        this.ExcelData = data;
        this.cols = make_cols(ws['!ref']);
        this.SayacVeriRender();
      };

      reader.readAsBinaryString(file);
    },
    SayacVeriRender() {
      this.$store.dispatch("Post", {
        Data: this.ExcelData,
        path: '_enerji/entegrasyon/'
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.MeskenListe = response.Liste;
            this.Form = {
              OkumaUcreti: 6.5,
              TahsilUcreti: 6.5,
              Bolge: 4,
            }
            this.Kaydet = true;
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    AboneGetir() {
      this.$store.dispatch("Get", {
        path: '_enerji/entegrasyon/' + this.BinaKodu
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.MeskenListe = response.Liste;
            this.Form = {
              Kod: this.BinaKodu,
              Koordinat: null,
              Aciklama: null,
              Ilgili: null,
              OkumaUcreti: 6.5,
              TahsilUcreti: 6.5,
              Bolge: 4,
              Iletisim: null,
              Adi: response.Bilgi.Adi,
              Adres: response.Bilgi.Adres + ' ' + response.Bilgi.Sehir,
              vDairesi: response.Bilgi.vDairesi,
              vNo: response.Bilgi.vNo
            }
            this.Kaydet = true;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
    },
    Submit() {
      this.lo = true;
      var PostForm = {
        Form: this.Form,
        MeskenListe: this.MeskenListe
      };
      this.$store.dispatch("Post", {Post: PostForm, path: '_enerji/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.lo = false;
            this.$message.success(response.Mesaj);
            this.$router.push('/bina/' + response.Bina_id)
          } else {
            this.lo = false;
            this.$message.error(response.Mesaj);
          }
        });
    }
  },
  created() {
    this.Hesap_id = JSON.parse(localStorage.getItem('_aiHesap'))['id'];
  }
}
</script>

<style scoped>
@import '~handsontable/dist/handsontable.full.css';
</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/EsayacBinaModal.vue